import baseApi from 'shared/api/baseApi';

export interface NotifyExecutiveActionRequiredToolState {
  businessRuleId: number | null;
  hasStoredRule: boolean;
  isToolEnabled: boolean;
}

export interface UpdateNotifyExecutiveActionRequiredToolBody {
  enabled: boolean;
  displayName?: string | null;
}

export interface UpdateNotifyExecutiveActionRequiredToolResponse extends NotifyExecutiveActionRequiredToolState {
  action: 'created' | 'updated' | 'restored';
}

const notifyExecutiveActionRequiredToolApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNotifyExecutiveActionRequiredToolState: build.query<NotifyExecutiveActionRequiredToolState, number>({
      query: (projectId) => ({
        url: `/backoffice/projects/${projectId}/notify-executive-action-required-tool`,
        method: 'GET' as const,
      }),
    }),
    updateNotifyExecutiveActionRequiredToolState: build.mutation<
      UpdateNotifyExecutiveActionRequiredToolResponse,
      { projectId: number; body: UpdateNotifyExecutiveActionRequiredToolBody }
    >({
      query: ({ projectId, body }) => ({
        url: `/backoffice/projects/${projectId}/notify-executive-action-required-tool`,
        method: 'PUT',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNotifyExecutiveActionRequiredToolStateQuery,
  useUpdateNotifyExecutiveActionRequiredToolStateMutation,
} = notifyExecutiveActionRequiredToolApi;
